/**
 * Created by Alex Aguilar on 7/4/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('flightService', flightService)

    flightService.$inject = ['$http', 'CONFIG', 'messageService'];

    function flightService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/flights',
            service = {
                getLoadForm: getLoadForm,
                getFlight: getFlight,
                updateFlight: updateFlight,
                getLoadFormCreate: getLoadFormCreate,
                saveSpecialFlight: saveSpecialFlight,
                getFlightByDepartureDateAndSegment: getFlightByDepartureDateAndSegment,
                getFlightsFromDate: getFlightsFromDate,
                getFlightByDepartureDateAndOrigin: getFlightByDepartureDateAndOrigin,
                updateBoardingGates: updateBoardingGates,
                getFlightByDepartureDateAndOriginDestiny: getFlightByDepartureDateAndOriginDestiny,
                deleteFlightById: deleteFlightById
            };

        return service;

        function getLoadForm(flightId){
            var params = (flightId != null) ? "?flightId=" + flightId : "";
            return $http.get(urlBase + "/loadForm" + params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('adminFlights');
                });
        }

        function getFlight(id, detailed){
            return $http.get(urlBase + "/" + id + '?detailed=' + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateFlight(id, flight, userLogin){
            return $http.put(urlBase + "/" + id+"?user_login="+ userLogin, flight)
                .then(function(response){
                    messageService.registerUpdate('')
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }

        function getLoadFormCreate(){
            return $http.get(urlBase + "/loadFormCreate")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function saveSpecialFlight(specialFlight, userLogin){
            return $http.post(urlBase+"?user_login="+ userLogin, specialFlight)
                .then(function(response){
                    messageService.register('');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getFlightByDepartureDateAndSegment(departureDate,originId, destinyId){
            return $http.get(urlBase + "/departureSegment/"+departureDate+"/"+originId+"_"+destinyId)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.flights : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getFlightsFromDate(date){
            return $http.get(urlBase + "/dateSearch/"+date)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getFlightByDepartureDateAndOrigin(departureDate,originId){
            return $http.get(urlBase + "/byDepartureDateOrigin/"+departureDate+"/"+originId)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.flights : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateBoardingGates(id, flight){
            return $http.put(urlBase + "/boardingGates/" + id, flight)
                .then(function(response){
                    messageService.registerUpdate('')
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }

        function getFlightByDepartureDateAndOriginDestiny(departureDate,originDestinyId){
            return $http.get(urlBase + "/byDepartureDate/"+departureDate+"/originDestiny/"+originDestinyId)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.flights : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function deleteFlightById(FlightId, userLogin){
            return $http.delete(urlBase + "/" + FlightId + "?user_login="+ userLogin)
                .then(function(response){
                    messageService.registerDelete('adminFlights');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('adminFlights');
                });
        }
    }
})();
